import React, { useEffect } from "react";
import { isMobile } from "react-device-detect";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../i18n/translations";
import Header from "../components/application/Header";
import Footer from "../components/application/Footer";
import DateModified from "../components/common/dateModified";

const REPORT_ISSUE_EMAIL = "DICE-INFC@forces.gc.ca";

const ReportIssuePage: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language];

  // Set document title
  useEffect(() => {
    document.title = t.contactPageTitle;
  }, [t.contactPageTitle]);

  // Render desktop mode
  if (!isMobile) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-blue-50">
        <a href="#main-content" className="skip-link">
          {t.skipToMainContent}
        </a>
        {/* Header */}
        <Header />

        {/* Main Content Section */}
        <main className="max-w-7xl mx-auto px-4 py-2 mb-28">
          {/* Page Title Section */}
          <div className="bg-white py-8">
            <h1 id="main-content" tabIndex={-1} className="text-4xl font-bold text-gray-900 mb-2">{t.reportAnIssue}</h1>
            <div className="w-24 h-1 bg-red-600"></div>
          </div>

          <div className="max-w-3xl space-y-6 text-lg text-gray-800 text-left">
            <p>{t.reportIssueDescription}</p>
            <p>{t.reportIncluds}</p>
            <ol className="mrgn-lft-lg lst-spcd">
              <li>{t.reportStep1}</li>
              <li>{t.reportStep2}</li>
              <li>{t.reportStep3}</li>
              <li>{t.reportStep4}</li>
            </ol>
            <p>{t.reportReason}</p>
            
            <div className="space-y-4">
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                  {t.contactEmail}
                </h2>
                <a 
                  href={`mailto:${REPORT_ISSUE_EMAIL}`}
                  className="text-blue-600 hover:underline text-lg"
                >
                  {REPORT_ISSUE_EMAIL}
                </a>
              </div>
            </div>
          </div>
        </main>

        <DateModified />
        <Footer />
      </div>
    );
  } else {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-blue-50">
        <a href="#main-content" className="skip-link">
          {t.skipToMainContent}
        </a>
        <Header />

        {/* Main Content Section */}
        <main className="max-w-7xl mx-auto px-4 py-2 mb-28">
          {/* Page Title Section */}
          <div className="bg-white py-8">
              <h1 id="main-content" tabIndex={-1} className="text-4xl font-bold text-gray-900 mb-2">{t.reportAnIssue}</h1>
              <div className="w-24 h-1 bg-red-600"></div>
          </div>

          <div className="max-w-3xl space-y-6 text-lg text-gray-800 text-left">
            <p>{t.reportIssueDescription}</p>
            <p>{t.reportIncluds}</p>
            <ol className="mrgn-lft-lg lst-spcd">
              <li>{t.reportStep1}</li>
              <li>{t.reportStep2}</li>
              <li>{t.reportStep3}</li>
              <li>{t.reportStep4}</li>
            </ol>
            <p>{t.reportReason}</p>
            
            <div className="space-y-4">
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-2">
                  {t.contactEmail}
                </h2>
                <a 
                  href={`mailto:${REPORT_ISSUE_EMAIL}`}
                  className="text-blue-600 hover:underline text-lg break-all"
                >
                  {REPORT_ISSUE_EMAIL}
                </a>
              </div>
            </div>
          </div>
        </main>

        <DateModified />
        <Footer />
      </div>
    );
  }
};

export default ReportIssuePage;
